import ColorContext from '@providers/ColorProvider/context/ColorContext';
import useAppColors from '@providers/ColorProvider/hooks/useAppColors';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

function ColorProvider({ children }:Props) {
  const { grayTheme } = useAppColors();
  return (
      <ColorContext value={{ grayTheme: grayTheme || 'WARM' }}>
          {children}
      </ColorContext>
  );
}

export default ColorProvider;
